/*
 * @Author: Kuiper
 * @Date: 2021-06-24 19:33:34
 */
import { Router } from 'vue-router'
import { store } from '/@/store'

export const DEFAULT_SESSION_TIMEOUT = 60 * 60 * 24 * 7 * 1000

export function setupRouterGuard(router: Router) {
  createPageGuard(router)
}

function createPageGuard(router: Router) {
  router.beforeEach((to, from, next) => {
    console.log('监听路由from:', from)
    console.log('监听路由to:', to)
    if (to.meta.requireAuth) {
      // 判断该路由是否需要登录权限
      if (store.state.user.userInfo.ak) {
        //判断本地是否存在access_token
        const user = store.state.user.userInfo.role == 'personal' ? true : false
        if (user == to.meta.isMine) {
          next()
        } else {
          if (user && to.meta.isMine) {
            next()
          } else if (user && !to.meta.isMine) {
            store.commit('user/clear')
            next({
              path: '/login',
              query: {
                role: 'company',
                // redirect: to.fullPath
              },
            })
          } else if (!user && to.meta.isMine) {
            store.commit('user/clear')
            next({
              path: '/',
              // query: {
              //     role: 'personal',
              //     // redirect: to.fullPath
              // }
            })
          } else {
            next()
          }
        }
      } else {
        if (to.meta.isMine) {
          next({
            path: '/introduce',
          })
        } else {
          next({
            path: '/login',
            query: {
              role: 'company',
              // redirect: to.fullPath
            },
          })
        }
      }
    } else {
      next()
    }
  })
}
